function fetchBlogPost(no){
    let sendNo = no;
    const postsArchive = document.querySelector('#posts-archive');
    const loader = document.querySelector('.loader')
    loader.style.display = 'block'

    $.ajax({
        type : "POST", 
        url : load_more_news_params.ajaxurl,
        data : {
            action: "get_blog_post",
            posts : sendNo
        },
        success: function(response) {
            postsArchive.innerHTML += response;
            loader.style.display = 'none';
        }
    })
}

function addEventListenerToMorePosts(){
    let btn = document.querySelector('#get_blog_posts_btn');
    if(btn){
        let no = 8;
        btn.addEventListener('click', (event) =>{
            event.preventDefault();
            fetchBlogPost(no);
            no +=4;
            if(+load_more_news_params.posts.publish <= no) btn.remove();
        })
    }
}
addEventListenerToMorePosts();